import React from 'react'
import Select from 'react-select'
import Polygon from '../icons/ui/Polygon'
import { feedbackStatusOption } from 'src/constants/trip'

interface IDropdownCellProps {
  feedbackStatus: string
  id: string
  updateFeedbackStatus: (tripId: string, feedbackStatus: string, prevFeedbackStatus: string) => Promise<any>
}

const customStyles = {
  container: (provided: any, state: any) => ({
    ...provided,
    padding: 0
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    width: 93,
    padding: 0,
    border: 'none',
    boxShadow: 'none'
  }),
  singleValue: (provided: any, state: any) => ({
    ...provided,
    padding: 0
  }),
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    padding: 0
  }),
  indicatorSeparator: (provided: any, state: any) => ({
    ...provided,
    display: 'none'
  })
}

export const DropdownCell = ({ feedbackStatus, id, updateFeedbackStatus }: IDropdownCellProps) => {
  const [selectedOption, setSelectedOption] = React.useState('')
  const [selectedId, setSelectedId] = React.useState('')

  const [all, ...feedbackStatOptions] = feedbackStatusOption
  const statusMap: { [key: string]: { label: string; value: string } } = {}
  feedbackStatusOption.map(({ label, value }) => (statusMap[value] = { label, value }))

  const handleFeedbackStatusChange = (tripId: string, feedbackStatus: any) => (selectedOption: any) => {
    handleChangeFeedbackStatus(tripId, selectedOption, feedbackStatus)
  }

  const handleChangeFeedbackStatus = async (tripId: string, selectedFeedbackStatus: any, prevFeedbackStatus: any) => {
    await updateFeedbackStatus(tripId, selectedFeedbackStatus.value, prevFeedbackStatus)
    setSelectedId(tripId)
    setSelectedOption(selectedFeedbackStatus.value)
  }

  const status =
    selectedId === id ? statusMap[selectedOption] : feedbackStatus ? statusMap[feedbackStatus] : feedbackStatusOption[2]

  return (
    <Select
      value={status}
      options={feedbackStatOptions}
      onChange={handleFeedbackStatusChange(id, feedbackStatus)}
      styles={customStyles}
      components={{ DropdownIndicator: CustomDropdownIndicator }}
    />
  )
}

const CustomDropdownIndicator = (props: any) => (
  <div>
    <Polygon className='icon--10x10 polygon' />
  </div>
)



// WEBPACK FOOTER //
// ./src/components/trip-feedbacks/DropdownCell.tsx